import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

export interface EeaContactValues {
  eeaContactName: string;
  eeaContactAddress: string;
  eeaContactEmail: string;
  eeaContactPhone?: string;
}

interface EditEeaContactDialogProps {
  open: boolean;
  onClose: () => void;
  onDone: (values: EeaContactValues) => void;
  values?: Partial<EeaContactValues>;
}

export function EditEeaContactDialog({
  open,
  onClose,
  onDone,
  values = {},
}: EditEeaContactDialogProps) {
  const [formValues, setFormValues] = React.useState<EeaContactValues>({
    eeaContactName: values.eeaContactName || "",
    eeaContactAddress: values.eeaContactAddress || "",
    eeaContactEmail: values.eeaContactEmail || "",
    eeaContactPhone: values.eeaContactPhone || "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onDone(formValues);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>EEA/UK Contact</DialogTitle>
        <DialogContent>
          <p>Add your business's EEA/UK contact details below.</p>
          <TextField
            label="Name"
            required
            fullWidth
            value={formValues.eeaContactName}
            onChange={(e) => setFormValues({ ...formValues, eeaContactName: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Physical Address"
            required
            fullWidth
            multiline
            rows={3}
            value={formValues.eeaContactAddress}
            onChange={(e) => setFormValues({ ...formValues, eeaContactAddress: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Email"
            required
            fullWidth
            type="email"
            value={formValues.eeaContactEmail}
            onChange={(e) => setFormValues({ ...formValues, eeaContactEmail: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Phone Number"
            fullWidth
            value={formValues.eeaContactPhone}
            onChange={(e) => setFormValues({ ...formValues, eeaContactPhone: e.target.value })}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={
              !formValues.eeaContactName ||
              !formValues.eeaContactAddress ||
              !formValues.eeaContactEmail
            }
          >
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
